module.exports = __webpack_public_path__ + "img/pic_2_3.e6c8690c.jpg";